/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="membershipTypes.module.ts" />

module Meevo.Plugins.MembershipTypes {
  import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
  class MembershipTypesController extends Meevo.Components.BaseClasses.DataMaintenanceControllerBase {
    public objectState;
    public coColumnsSet = [
      { header: "Owned By", fieldName: 'OwnedByLocationName', sortDirection: null, width: 35 },
      { header: "Located At", fieldName: 'AtLocationName', sortDirection: null, width: 35 },
      { header: "Status", fieldName: 'ObjectState', sortDirection: null, width: 20 }
    ];

    // statically inject constructor resources
    static $inject = [
      "meevo.AppSettings",
      "$http",
      "meevo.components.common.DataService",
      "meevo.components.modal.ModalService",
      "meevo.components.common.IdentityService",
      "meevo.components.logging.LoggingService",
      "meevo.components.common.SecurityService",
      "meevo.components.tracking.TrackingService",
      "$rootScope",
      "$scope",
      "$state",
      "meevo.ContextParams",
      'meevo.components.short-cuts.ShortCutsService',

      "meevo.components.busy.BusyService",
      "$translate"];

    constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
      protected $http: angular.IHttpService,
      protected dataService: Meevo.Components.BaseClasses.IDataService,
      protected modalService: Meevo.Components.Modal.IModalService,
      protected identityService: Meevo.Components.Common.IIdentityService,
      protected loggingService: Meevo.Components.Logging.ILoggingService,
      protected securityService: Meevo.Components.Common.ISecurityService,
      protected trackingService: Meevo.Components.Tracking.ITrackingService,
      protected $rootScope: angular.IRootScopeService,
      protected $scope: angular.IScope,
      protected $state: any,
      protected contextParams: Meevo.IContextParams,
      protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,

      protected busyService: Meevo.Components.Busy.IBusyService,
      protected $translate: angular.translate.ITranslateService) {

      super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

      this.objectState = ObjectStateEnum;
    }


    createContext(): void {
      let vm = this;
      vm.busyService.start();
      vm.securityService.checkSection(vm.meevoSecurityKeys.MEMBERSHIP_MEMBERSHIPTYPE).then(() => {
        vm.busyService.stop();
        vm.context = new MembershipTypesContext(this.appSettings, vm.$scope, vm.dataService, vm.modalService, vm.identityService, vm.loggingService, this.securityService, vm.trackingService, vm.$rootScope, vm.busyService, vm.$translate);
        vm.context.activate(vm.selectedItemId, null, vm.asLocationId);
        vm.context.deactivate = () => {
          vm.visualState = Model.MaintenanceFormVisualState.Search;
        };

        vm.context.locationFieldList = [
            { field: 'isTaxable', label: this.$translate.instant("LABEL_TAXABLE_QUESTION"), checked: false },
        ];

        //empContext.isEmployee = true;
      }).catch(() => {
        vm.busyService.stop();
      });
    }
  }

  angular.module("meevo.plugins.membershipTypes")
    .controller("meevo.plugins.membershipTypes.MembershipTypesController", MembershipTypesController);
}